import { FC, useState, useEffect } from 'react'
import { FaBars, FaTimes, FaPhoneAlt } from 'react-icons/fa'

const Navbar: FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const navLinks = [
    { href: '#about', label: 'About' },
    { href: '#services', label: 'Services' },
    { href: '#contact', label: 'Contact' },
  ]

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3">
            <img
              src="/assets/logo white.jpg"
              alt="Studio Figura Logo"
              className="h-16 w-auto"
            />
            <span className="text-primary font-bold text-lg sm:text-xl uppercase tracking-wide hidden sm:block">
              Studio Figura Larnaca
            </span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-text-dark font-medium text-sm uppercase tracking-wide hover:text-primary transition-colors relative after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-primary after:transition-all hover:after:w-full"
              >
                {link.label}
              </a>
            ))}
            <a
              href="tel:+35724252225"
              className="btn-header"
            >
              <FaPhoneAlt className="text-sm" />
              <span>Call Now</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-primary text-2xl p-2 hover:bg-primary/10 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      <div
        className={`md:hidden fixed top-20 left-0 right-0 bg-white shadow-lg transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-4 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className="text-text-dark font-medium text-lg uppercase py-2 hover:text-primary transition-colors border-b border-gray-100"
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:+35724252225"
            onClick={() => setIsOpen(false)}
            className="btn-header justify-center mt-2"
          >
            <FaPhoneAlt />
            <span>Call Now</span>
          </a>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
